import React, { SyntheticEvent, useState } from 'react'
import InfoBlock from '../../../components/InfoBlock'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import { IsinMapTable } from './IsinMapTable'
import { CompanyEvents } from './CompanyEvents'
import IsinsApi from '../../../../api/IsinsApi'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Stack from '@mui/material/Stack'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { IsinEntity } from '@finance-lab/utils/types'

enum Type {
    INBOX = 'inbox',
    ARCHIVED = 'archived',
}

type IsinMapComponent = React.FC<{
    unusedIsins: IsinEntity[]
    setUnusedIsins: (unusedIsins: IsinEntity[]) => void
    startDate: Date
    setStartDate: React.Dispatch<React.SetStateAction<Date>>
    onlyIsinsWithEvents: boolean
    setOnlyIsinsWithEvents: React.Dispatch<React.SetStateAction<boolean>>
}>

export const IsinMap: IsinMapComponent = ({
    unusedIsins,
    setUnusedIsins,
    startDate,
    setStartDate,
    onlyIsinsWithEvents,
    setOnlyIsinsWithEvents,
}: {
    unusedIsins: IsinEntity[]
    onlyIsinsWithEvents: boolean
    setOnlyIsinsWithEvents: (v: boolean) => void
    setUnusedIsins: (isins: IsinEntity[]) => void
    startDate: Date
    setStartDate: (d: Date) => void
}) => {
    const [selectedTab, setSelectedTab] = useState<Type>(Type.INBOX)
    const [selectedIsin, setSelectedIsin] = useState<IsinEntity | null>(null)
    const isinsApi = new IsinsApi()

    const handleChange = (event: SyntheticEvent, newValue: Type) => setSelectedTab(newValue)

    const handleArchive = async (isinToArchive: IsinEntity, sendArchiveRequest = true) => {
        if (sendArchiveRequest) {
            await isinsApi.archiveIsin(isinToArchive.isin)
        }
        const filteredUnusedIsins = unusedIsins.filter((unusedIsin) => unusedIsin.isin !== isinToArchive.isin)
        setUnusedIsins(filteredUnusedIsins)
    }
    return (
        <Grid container spacing={6}>
            <Grid size={{ xs: 12, md: 6 }}>
                <InfoBlock
                    title={
                        <Stack direction='row' alignItems='top' justifyContent='space-between' spacing={2}>
                            <Typography variant='h6'>ISIN</Typography>
                            <Stack>
                                <DatePicker
                                    label='Startdatum'
                                    value={startDate}
                                    onChange={(newStartDate) => {
                                        if (newStartDate) setStartDate(newStartDate)
                                    }}
                                />
                                <FormControlLabel
                                    value='Visa enbart ISIN med emissioner/TO'
                                    control={
                                        <Checkbox
                                            checked={onlyIsinsWithEvents}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setOnlyIsinsWithEvents(event.target.checked)
                                            }}
                                        />
                                    }
                                    label='Visa enbart ISIN med emissioner/TO'
                                    labelPlacement='end'
                                    sx={{ py: 2 }}
                                />
                            </Stack>
                        </Stack>
                    }
                >
                    <TabContext value={selectedTab}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={selectedTab} onChange={handleChange}>
                                <Tab label={`Inbox (${unusedIsins.length})`} value={Type.INBOX} />
                                <Tab label='Arkiverade' value={Type.ARCHIVED} disabled />
                            </Tabs>
                        </Box>
                        <TabPanel value={Type.INBOX}>
                            <IsinMapTable
                                unusedIsins={unusedIsins}
                                onArchive={handleArchive}
                                selectedIsin={selectedIsin}
                                setSelectedIsin={setSelectedIsin}
                            />
                        </TabPanel>
                    </TabContext>
                </InfoBlock>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                {selectedIsin ? (
                    <InfoBlock title='Emissioner och Teckningsoptioner'>
                        <CompanyEvents
                            selectedIsin={selectedIsin}
                            setSelectedIsin={setSelectedIsin}
                            onArchiveIsin={handleArchive}
                        />
                    </InfoBlock>
                ) : null}
            </Grid>
        </Grid>
    )
}
